import { BarChart3 } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ComingSoon } from '../components/ui/ComingSoon';

export function PinStatsPage() {
  return (
    <>
      <PageHeader
        icon={BarChart3}
        title="Pin Stats"
        description="Real engagement metrics for pins your connected account owns."
      />
      <ComingSoon what="Pin Stats UI" />
    </>
  );
}
